import { render, staticRenderFns } from "./task_timer_icon.vue?vue&type=template&id=4ed3d084"
import script from "./task_timer_icon.vue?vue&type=script&lang=js"
export * from "./task_timer_icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports